import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { BLACK, WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

// COMPONENTS
import DialogCTA from '@/components/Dialogs/DialogCTA/DialogCTA';

export const StyledDialog = styled(DialogCTA)`
  .MuiDialog-paper {
    overflow: hidden;
    max-width: 734px;
  }

  .dialog-cta {
    &__image-wrapper {
      position: relative;
      margin: -60px -24px 80px;

      img {
        width: 100%;
      }

      ${breakpoints.down('xs')} {
        margin-bottom: 60px;
      }
    }

    &__close-btn {
      color: ${BLACK};
    }

    &__app-logo {
      position: absolute;
      bottom: -56px;
      left: 50%;
      margin-left: -156px;
      background-color: ${WHITE};
      border-radius: 12px;
      width: 312px;
      height: 192px;
      padding: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 1px 4px 4.5px 0 ${rgba(BLACK, 0.09)};

      ${breakpoints.down('xs')} {
        width: 156px;
        height: 96px;
        bottom: -30px;
        margin-left: -78px;
      }

      img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
      }
    }

    &__inner-content {
      margin-top: 30px;
    }
  }
`;

export default StyledDialog;
